import styled from "styled-components";

export const Title = styled.h2`
  font-size: 24px;
  line-height: 36px;
  text-decoration: capitalize;
  font-family: "Merriweather", serif;
  text-align: left;
  color: #4a4a4a;
`;

export const SubTitle = styled.h6`
  font-size: 14px !important;
  text-align: left !important;
  margin-bottom: 14px !important;
  color: #131313;
`;

export const Statement = styled.h2`
  font-size: 28px;
  line-height: 42px;
  font-family: "Book Antiqua";
  text-align: left;
  color: #000;
  font-weight: 400 !important;
  margin-bottom: 16px !important;
`;
export const BlueText = styled.span`
  color: #0182ff;
`;

export const SubStatement = styled.h6`
  font-size: 14px !important;
  font-weight: 700 !important;
  text-align: left !important;
  margin-bottom: 14px !important;
  color: #404040 !important;
`;

export const Input = styled.input`
  width: 20%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #0182ff;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #fff;
  border-bottom: 1px solid #ced4da !important;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  display: inline;
  &:focus {
    outline: none;
  }
`;

export const BackImage = styled.img`
  display: inline-block;
  position: relative;
  width: 280px;
  opacity: 0.1;
  left: -105px;
  top: -155px;
  z-index: -1;
`;
